import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '../core/services/environment.service';
import { AuthService } from '../auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html'
})
export class LandingComponent implements OnInit {

  public store: string;
  public theme: string;
  public content: any;
  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    private envService: EnvironmentService
  ) { }

  ngOnInit() {
    this.store = this.getStoreMapping();
    this.theme = this.envService.getTheme();
    this.translateService.get('LANDING.' + this.store.toLocaleUpperCase()).subscribe(
      (content: any) => {
        this.content = content;
      }
    );
  }

  public getStoreMapping() {
    const landingContent = this.envService.getStore('landingContent');
    if (landingContent && landingContent !== undefined ) {
      return landingContent;
    }
    return this.envService.getStore();
  }

  public loadLoginPage() {

    this.authService.login();

  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/landing/landing.component.ts